<script>
  import { checkbox } from 'vue-strap';
  import projetoServico from '~modulos/projeto/servico';

  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true,
      },
      tipos: {
        type: Object,
        required: true,
      },
      motivos: {
        type: Object,
        required: true,
      },
      rubricas: {
        type: Array,
        required: true,
      },
      rubricaSubrubrica: {
        type: Object,
        required: true,
      },
      edicao: {
        type: Boolean,
        required: false,
        default: false,
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        subrubricas: [],
      }
    },
    computed: {
      motivoContador() {
        let quantidadeCaracteres = this.motivos.adiantamento ?
          this.motivos.adiantamento.length : 0;

        return 500 - quantidadeCaracteres;
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
      listaDeSubrubricas(idProjeto = null, idRubrica = null) {
        idProjeto = this.solicitacao.idProjeto || idProjeto;
        idRubrica = this.rubricaSubrubrica.idRubrica || idRubrica;

        this.rubricaSubrubrica.idSubrubrica = '';
        this.subrubricas = [];

        if (!idRubrica) return;

        return projetoServico
          .subrubricas(idProjeto, idRubrica)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      limparSubrubricas() {
        this.subrubricas = [];
      }
    },
    watch: {
      'rubricaSubrubrica.idRubrica': 'limparSubrubricas'
    }
  }
</script>

<template>
  <div>

    <div class="row" v-if="!edicao">
      <div class="col-xs-12">
        <div class="form-group chackboxes">
          <checkbox
              v-model="tipos.adiantamento"
              :true-value="true"
              type="success">
            Adiantamento
          </checkbox>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.exibirRubricaSubrubricaSolicitacaoWeb">
      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('rubrica')}">
          <label class="control-label" for="rubrica">Rubrica</label>

          <select
            class="form-control"
            id="rubrica"
            v-model="rubricaSubrubrica.idRubrica"
            data-vv-name="rubrica"
            data-vv-as="rubrica"
            :disabled="!tipos.adiantamento"
            v-validate="'required'"
            @change="listaDeSubrubricas">
            <option value="">Selecione...</option>
            <option
              :value="rubrica.id"
              v-for="rubrica in rubricas">
              {{ rubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('rubrica')">{{ errors.first('rubrica') }}</p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('subrubrica')}">
          <label class="control-label" for="subrubrica">Subrubrica</label>

          <select
            class="form-control"
            id="subrubrica"
            v-model="rubricaSubrubrica.idSubrubrica"
            data-vv-name="subrubrica"
            data-vv-as="subrubrica"
            :disabled="!tipos.adiantamento"
            v-validate="'required'">
            <option value="">Selecione...</option>
            <option
              :value="subrubrica.id"
              v-for="subrubrica in subrubricas">
              {{ subrubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('subrubrica')">{{ errors.first('subrubrica') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('motivoAdiantamento')}">
          <label class="control-label" for="motivo-diaria">Motivo ({{ motivoContador }})</label>

          <textarea
              class="form-control"
              id="motivo-diaria"
              v-model="motivos.adiantamento"
              :disabled="!tipos.adiantamento"
              maxlength="500"
              data-vv-name="motivoAdiantamento"
              data-vv-as="motivo"
              v-validate="tipos.adiantamento ? 'required' : ''">
          </textarea>

          <p class="text-danger" v-show="errors.has('motivoAdiantamento')">{{ errors.first('motivoAdiantamento') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('valorAdiantamento')}">
          <label class="control-label" for="valor-adiantamento">Valor</label>

          <div class="input-group">
            <div class="input-group-addon">R$</div>

            <input
                id="valor-adiantamento"
                class="form-control text-right"
                type="text"
                v-model="solicitacao.valorAdiantamento"
                :disabled="!tipos.adiantamento"
                v-mascara="'moeda'"
                data-vv-name="valorAdiantamento"
                data-vv-as="valor"
                v-validate="tipos.adiantamento ? 'required' : ''">
          </div>

          <p class="text-danger" v-show="errors.has('valorAdiantamento')">{{ errors.first('valorAdiantamento') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso/componentes/compartilhado/FormAdiantamento.vue